<!--
 * @Author: your name
 * @Date: 2022-03-30 17:40:42
 * @LastEditTime: 2022-04-02 15:43:39
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \mingyao\src\App.vue
-->
<template>
  <div id="app">
    <div id="nav">
      <div class="title">
        <div class="logo"></div>
        <div class="text">
        <div>江苏明耀工程技术有限公司</div>
        <div class="english">Jiangsu Mingyao Engineering Technology Co. Ltd</div>
        </div>
      </div>
      <div class="item" @click="scrollTop">
        <router-link to="/contact">联系我们</router-link>
        <div>contact</div>
      </div>
      <div class="item" @click="scrollTop">
        <router-link to="/news">新闻中心</router-link>
        <div>news</div>
      </div>
      <div class="item" @click="scrollTop">
        <router-link to="/power">公司资质</router-link>
        <div>qualifications</div>
      </div>
      <div class="item" @click="scrollTop">
        <router-link to="/case">公司业绩</router-link>
        <div>achievements</div>
      </div>
      <div class="item" @click="scrollTop">
        <router-link to="/service">服务项目</router-link>
        <div>service</div>
      </div>
      <div class="item" @click="scrollTop">
        <router-link to="/about">公司简介</router-link>
        <div>introduction</div>
      </div>
      <div class="item" @click="scrollTop">
        <router-link to="/">首页</router-link>
        <div>home</div>
      </div>
    </div>
    <div class="router-view">
      <router-view class="root-view" />
    </div>
  </div>
</template>
<script>
export default {
  name: "App",
  methods:{
    scrollTop(){
      document.getElementsByClassName("router-view")[0].scrollTop=0;
    }
  }
};
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
* {
  box-sizing: border-box;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
}
html,
body {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  margin: 0;
  padding: 0;
}
.router-view {
  height: calc(100% - 6rem);
  overflow-y: auto;
  overflow-x:hidden;
  position: absolute;
  width:100%;
}
.root-view {
  width: 100%;
  height: 100%;
}
#nav {
  padding: 2rem;
  background-color: white;
  height: 6rem;
  a {
    font-weight: bold;
    color: #1560ac;
    margin: 0 0.5rem 0 0.5rem;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
  box-shadow: 0px 3px 2px rgba(233,233,233,0.9);
  .item {
    width: 8rem;
    text-align: center;
    float: right;
  }
  .title{
    position: absolute;
    left:5rem;
    top:1.5rem;
    color:rgb(10,100,200);
    font-size: 1.8rem;
    .english{
      font-size: 1rem;
    }
    .logo{
      width:3rem;
      height:3rem;
      margin-right:0.5rem;
      display: inline-block;
      background-image:url(./assets/logo.png) ;
    }
    .text{
      display: inline-block;
    }
  }
}
::-webkit-scrollbar-thumb {
  width: 8px;
  min-height: 15px;
  background: rgba(0, 0, 0, 0.3);
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  border-radius: 5px;
}
::-webkit-scrollbar {
  height: 8px;
  width: 8px;
  background: rgba(222, 222, 222, 0.5);
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  border-radius: 5px;
}
@media screen and (max-width: 1370px) {
  body,html{
    font-size: 50%;
  } 
}
@media screen and (min-width:1370px) and (max-width: 1800px) {
  body,html{
    font-size: 70%;
  } 
}
@media screen and (min-width: 1801px) {
  body,html{
    font-size: 100%;
  } 
}
</style>
